module.exports = __webpack_public_path__ + "img/borderCircularRightTopWhite.64700090.svg";